import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Innovacrystaonrentinnavimumbai() {



const cardData = {
  keyword: " Innova Crysta On Rent in Navi Mumbai",

headingDescription:
  "Omshree Cab offers dependable and comfortable Innova Crysta on rent in Navi Mumbai for travelers who want a premium, spacious, and smooth ride for city travel, airport transfers, family outings, corporate travel, or outstation trips. The Toyota Innova Crysta is a modern multi‑purpose vehicle (MPV) known for its refined drive quality, generous space, superior comfort, and advanced safety features, making it ideal for families, groups, and long‑distance journeys. We provide flexible rental options including one‑way bookings, round trips, full‑day packages, hourly rentals, and long‑distance travel plans with transparent pricing and no hidden charges. Each Innova Crysta in our fleet is air‑conditioned, well‑maintained, and driven by an experienced chauffeur familiar with Navi Mumbai’s roads and traffic. With easy online booking, punctual pickups from anywhere in Navi Mumbai (including airport, railway station, hotels, and residences), and 24/7 customer support, renting an Innova Crysta in Navi Mumbai becomes a seamless and stress‑free travel experience.",

topPlaces: [
  {
    title: "Central Park Kharghar",
    description:
      "Central Park in Kharghar is one of the largest and most scenic urban parks in Navi Mumbai. It features landscaped gardens, fountains, jogging tracks, open green spaces, and recreational areas where families and visitors can relax, enjoy nature, and take strolls. Many people visit in the early morning or evening for walks, picnics, and photography. Renting an Innova Crysta ensures ample seating and comfort for group travel to this pleasant outdoor destination."
  },
  {
    title: "Pandavkada Waterfalls",
    description:
      "Pandavkada Waterfalls is a natural attraction near Kharghar, especially popular during the monsoon season when water cascades down the rocky cliffs surrounded by lush greenery. Visitors often come here for nature walks, scenic views, trekking, and photography. Families and nature lovers can comfortably reach this picturesque spot with an Innova Crysta rental from Navi Mumbai, making it perfect for day outings."
  },
  {
    title: "Seawoods Grand Central Mall",
    description:
      "Seawoods Grand Central Mall is a major lifestyle and shopping destination in Navi Mumbai, featuring popular retail brands, restaurants, cafes, entertainment zones, and a multiplex cinema. Visitors enjoy shopping, dining, and leisure activities with friends and family. Renting an Innova Crysta makes it easy to travel here in comfort, with adequate luggage space and smooth city driving."
  },
  {
    title: "Utsav Chowk",
    description:
      "Utsav Chowk is a well‑known landmark in Kharghar, known for its impressive architecture and decorative fountains. The area around the chowk includes cafes, restaurants, and shopping outlets where visitors can spend leisure time. It is popular for evening outings and photography. A rental Innova Crysta provides comfortable transport for groups and families visiting this vibrant destination."
  },
  {
    title: "Palm Beach Road",
    description:
      "Palm Beach Road is a scenic and well‑planned road connecting Vashi, Nerul, and Belapur in Navi Mumbai. It offers beautiful views of the waterfront, city skyline, and well‑maintained urban landscape. Visitors often enjoy evening drives or quick photo stops along this stretch. Renting an Innova Crysta provides a smooth, roomy ride for such city drives and sightseeing excursions."
  },
  {
    title: "Belapur Fort",
    description:
      "Belapur Fort is a historic site in Navi Mumbai that reflects the region’s heritage and architectural past. The fort’s ruins and surrounding greenery attract visitors interested in history and peaceful outdoor spaces. Families and tourists can explore the site, take photographs, and enjoy the calm environment. An Innova Crysta rental ensures comfortable travel to this historical location."
  },
  {
    title: "ISKCON Kharghar",
    description:
      "ISKCON Kharghar is a spiritual destination dedicated to Lord Krishna and offers a peaceful and devotional atmosphere. Devotees and visitors come to participate in prayers, spiritual programs, and cultural events organized by the community. Renting an Innova Crysta provides comfortable and hassle‑free transportation for devotees and tourists visiting this temple."
  },
  {
    title: "Golf Course Kharghar",
    description:
      "The Kharghar Golf Course is one of the largest golf courses in Navi Mumbai and attracts sports enthusiasts and visitors who enjoy outdoor recreation. The surrounding green fields and scenic views offer a relaxing escape from city life. Renting an Innova Crysta makes it easy for families and groups to travel comfortably to this leisure destination."
  },
  {
    title: "Nerul Balaji Temple",
    description:
      "Nerul Balaji Temple is a religious site dedicated to Lord Venkateswara and features traditional South Indian architecture. The peaceful spiritual ambience and beautiful carvings draw devotees and tourists alike. An Innova Crysta rental provides a convenient and comfortable travel option for those planning a temple visit in Navi Mumbai."
  },
  {
    title: "Sagar Vihar",
    description:
      "Sagar Vihar is a tranquil waterfront promenade in Vashi overlooking the Thane Creek, popular for evening walks, photography, and family outings. Visitors gather here to enjoy the cool breeze, sunset views, and relaxed environment. Renting an Innova Crysta offers a roomy and comfortable ride to this scenic waterfront spot for friends and families."
  }
],



services: [
{
name: "Innova Crysta on Rent Navi Mumbai",
description: "Innova Crysta on rent in Navi Mumbai provides premium and spacious travel for families, corporate travelers, and tourists. The Toyota Innova Crysta is known for its luxury interiors, smooth suspension, and powerful highway performance. Our vehicles are ideal for airport transfers, local city travel, and long-distance outstation journeys. Professional drivers ensure safe driving and punctual pickup across Navi Mumbai locations. Comfortable seating for 6–7 passengers makes it perfect for group travel. AC comfort, large luggage space, and reliable service guarantee a relaxed travel experience."
},
{
name: "Innova Crysta Rental Navi Mumbai",
description: "Innova Crysta rental in Navi Mumbai offers comfortable and reliable transportation for business trips, family travel, and tourism. The vehicle provides spacious seating, modern interiors, and smooth highway performance for long journeys. Ideal for airport transfers, corporate travel, and weekend trips from Navi Mumbai. Our experienced drivers ensure safe driving and timely pickup services. Flexible booking options are available for local travel as well as outstation trips. Customers can easily reserve vehicles for comfortable group transportation."
},
{
name: "Innova Crysta Cab Service Navi Mumbai",
description: "Innova Crysta cab service in Navi Mumbai provides premium taxi transportation for city rides and outstation travel. The vehicle offers luxury seating, powerful AC cooling, and spacious legroom for comfortable journeys. Ideal for airport pickups, corporate travel, and family tours. Professional drivers ensure safe driving and punctual service across Navi Mumbai areas. The cab service is suitable for long-distance travel due to its excellent ride comfort. Customers enjoy smooth travel with reliable booking support."
},
{
name: "Innova Crysta Taxi Navi Mumbai",
description: "Innova Crysta taxi in Navi Mumbai is a popular choice for passengers seeking luxury travel with spacious seating and reliable performance. The vehicle provides comfortable interiors suitable for both local and outstation journeys. Ideal for airport transfers, corporate meetings, and family trips. Professional drivers ensure smooth driving and timely pickups across Navi Mumbai locations. Passengers enjoy relaxed travel with premium comfort features. The taxi service ensures safe and convenient transportation."
},
{
name: "Luxury Innova Crysta Navi Mumbai",
description: "Luxury Innova Crysta in Navi Mumbai offers executive-level transportation for premium travel requirements. The vehicle features elegant interiors, spacious seating, and superior comfort for long journeys. Ideal for VIP travel, corporate clients, and luxury airport transfers. Professional chauffeurs ensure safe driving and courteous service throughout the trip. The car provides powerful AC cooling and excellent suspension for smooth highway rides. Perfect for travelers seeking premium comfort and reliability."
},
{
name: "Innova Crysta Airport Cab Navi Mumbai",
description: "Innova Crysta airport cab in Navi Mumbai provides comfortable airport pickup and drop services for travelers. The vehicle offers spacious seating and luggage capacity suitable for airport travel. Professional drivers monitor flight schedules to ensure timely pickup and drop services. Ideal for business travelers, families, and group airport transfers. AC comfort and smooth driving ensure relaxed travel to and from the airport. Customers enjoy reliable airport transportation across Navi Mumbai."
},
{
name: "Innova Crysta Outstation Cab Navi Mumbai",
description: "Innova Crysta outstation cab in Navi Mumbai provides comfortable long-distance travel for tourists and families. The vehicle offers excellent highway performance and spacious seating for extended journeys. Ideal for travel to destinations like Pune, Shirdi, Nashik, and Lonavala. Professional drivers ensure safe highway driving and punctual pickups. The cab service provides comfortable AC travel with sufficient luggage space. Perfect for weekend trips and long-distance tours."
},
{
name: "Innova Crysta One Way Cab Navi Mumbai",
description: "Innova Crysta one way cab in Navi Mumbai offers economical intercity transportation without return travel charges. This service is ideal for passengers who require only drop services to another city. The vehicle provides spacious seating and comfortable highway performance. Professional drivers ensure safe driving and timely pickup services. Ideal for airport transfers and outstation drop trips. Customers enjoy flexible and convenient travel options."
},
{
name: "Innova Crysta Round Trip Taxi Navi Mumbai",
description: "Innova Crysta round trip taxi in Navi Mumbai provides convenient travel for passengers planning return journeys. The vehicle remains available according to the travel schedule ensuring flexibility for sightseeing and meetings. Spacious seating and powerful AC ensure comfortable travel during long-distance journeys. Professional drivers ensure safe driving and reliable service. Ideal for family tours and corporate travel. Customers enjoy comfortable two-way transportation."
},
{
name: "Cheap Innova Crysta Rental Navi Mumbai",
description: "Cheap Innova Crysta rental in Navi Mumbai provides budget-friendly luxury travel for passengers seeking premium comfort at affordable prices. The vehicle offers spacious seating and reliable highway performance suitable for both local and outstation journeys. Ideal for family trips, airport travel, and group transportation. Professional drivers ensure safe driving and punctual pickups across Navi Mumbai. Flexible booking options allow customers to plan travel easily. The service provides comfortable transportation without compromising quality."
},
{
name: "Innova Crysta Cab Booking Navi Mumbai",
description: "Innova Crysta cab booking in Navi Mumbai allows passengers to easily reserve premium vehicles for travel needs. Customers can book cabs through phone or online platforms with quick confirmation. The vehicle provides spacious seating and comfortable interiors for group travel. Ideal for airport transfers, city rides, and outstation journeys. Professional drivers ensure safe driving and reliable pickup services. The booking process is simple and convenient for travelers."
},
{
name: "Innova Crysta Taxi Booking Online Navi Mumbai",
description: "Innova Crysta taxi booking online in Navi Mumbai provides quick and convenient digital reservations for travelers. Customers can easily book vehicles online with instant confirmation and flexible scheduling. The car offers spacious seating and comfortable interiors suitable for family and corporate travel. Ideal for airport transfers and long-distance journeys. Professional drivers ensure safe driving and punctual service. Online booking ensures hassle-free travel planning."
},
{
name: "Best Innova Crysta Rental Navi Mumbai",
description: "Best Innova Crysta rental in Navi Mumbai offers premium transportation with reliable service and comfortable vehicles. The car provides spacious seating, luxury interiors, and smooth highway performance. Ideal for corporate travel, family tours, and airport transfers. Professional drivers ensure safe driving and timely pickups across Navi Mumbai locations. The service ensures comfortable travel for long journeys. Customers receive dependable and high-quality transportation."
},
{
name: "Corporate Innova Crysta Cab Navi Mumbai",
description: "Corporate Innova Crysta cab in Navi Mumbai provides professional transportation solutions for business travelers and corporate teams. The vehicle offers spacious seating and comfortable interiors suitable for executive travel. Ideal for corporate meetings, airport transfers, and staff transportation. Professional drivers ensure punctual pickups and smooth driving for business trips. The service guarantees reliable and comfortable travel for corporate clients. Businesses can rely on efficient transportation support."
}
],

tableData: [
["Innova Crysta on Rent Navi Mumbai","Innova Crysta Rental Navi Mumbai"],
["Innova Crysta Cab Service Navi Mumbai","Innova Crysta Taxi Navi Mumbai"],
["Luxury Innova Crysta Navi Mumbai","Innova Crysta Airport Cab Navi Mumbai"],
["Innova Crysta Outstation Cab Navi Mumbai","Innova Crysta One Way Cab Navi Mumbai"],
["Innova Crysta Round Trip Taxi Navi Mumbai","Cheap Innova Crysta Rental Navi Mumbai"],
["Innova Crysta Cab Booking Navi Mumbai","Innova Crysta Taxi Booking Online Navi Mumbai"],
["Best Innova Crysta Rental Navi Mumbai","Corporate Innova Crysta Cab Navi Mumbai"]
],


whychoose: [
  {
    WhyChooseheading: "Premium 7-Seater Travel Comfort",
    WhyChoosedescription: "Toyota Innova Crysta is one of the most comfortable 7-seater vehicles for family trips, airport transfers, and corporate travel in Navi Mumbai. It offers spacious seating, powerful AC, and large luggage space for long-distance journeys."
  },
  {
    WhyChooseheading: "Transparent Rental Pricing",
    WhyChoosedescription: "Omshree Cabs provides transparent pricing for Innova Crysta on rent in Navi Mumbai. Customers receive clear information about per-kilometer rates, driver allowance, and toll charges before confirming the booking."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "Our Innova Crysta rental service in Navi Mumbai operates 24 hours a day. Whether you need a cab for airport pickup, late-night travel, or early morning trips, our vehicles are available anytime."
  },
  {
    WhyChooseheading: "Clean & Well Maintained Vehicles",
    WhyChoosedescription: "All Innova Crysta vehicles are regularly serviced, cleaned, and sanitized to provide a safe and comfortable travel experience for passengers."
  },
  {
    WhyChooseheading: "Flexible Local & Outstation Packages",
    WhyChoosedescription: "We offer flexible travel packages including local Navi Mumbai travel, airport transfers, one-way trips, and outstation tours to destinations like Pune, Nashik, Lonavala, Shirdi, and Mahabaleshwar."
  },
  {
    WhyChooseheading: "Ideal for Families & Group Travel",
    WhyChoosedescription: "Innova Crysta is ideal for families, corporate teams, and group travelers as it comfortably seats 6–7 passengers with luggage space."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Navi Mumbai",
    WhyChoosedescription: "Omshree Cabs provides convenient pickup from homes, offices, hotels, railway stations, and business locations across Navi Mumbai."
  },
  {
    WhyChooseheading: "Trusted Cab Service",
    WhyChoosedescription: "Omshree Cabs is trusted by many travelers for Innova Crysta rental in Navi Mumbai thanks to our punctual drivers, comfortable vehicles, and professional service."
  }
]
};

const faqData = [
  { question: "Do you provide Innova Crysta on rent in Navi Mumbai?", answer: "Yes, Omshree Cabs provides Toyota Innova Crysta rental services in Navi Mumbai for local travel, airport transfers, and outstation trips." },
  { question: "What is the seating capacity of Innova Crysta?", answer: "Toyota Innova Crysta usually accommodates 6 to 7 passengers comfortably with luggage space." },
  { question: "What is the per km rate for Innova Crysta in Navi Mumbai?", answer: "Innova Crysta rental rates generally start around ₹18 to ₹20 per km for outstation travel depending on the provider and travel package." },
  { question: "Can I book Innova Crysta for airport pickup?", answer: "Yes, Innova Crysta can be booked for Mumbai Airport and Navi Mumbai Airport pickup and drop services." },
  { question: "Is Innova Crysta suitable for outstation trips?", answer: "Yes, Innova Crysta is commonly used for outstation trips from Navi Mumbai to destinations like Pune, Shirdi, Nashik, Mahabaleshwar, and Goa." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all Innova Crysta vehicles provided by Omshree Cabs are fully air-conditioned." },
  { question: "Do you provide driver with the car?", answer: "Yes, all Innova Crysta rentals include a professional driver for safe and comfortable travel." },
  { question: "Can Innova Crysta be used for corporate travel?", answer: "Yes, Innova Crysta is widely used for corporate travel and executive transportation." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially during weekends, holidays, and peak travel seasons." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rahul Deshmukh",
    feedback:
      "We booked an Innova Crysta from Omshree Cabs for our Navi Mumbai to Pune trip. The vehicle was very comfortable and the driver was professional.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sneha Patil",
    feedback:
      "Excellent Innova Crysta rental service in Navi Mumbai. Clean car, punctual driver, and smooth journey.",
    rating: 5
  }
];








































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];









const jsonData = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "Omshree Cab",
  "description": "Omshree Cab provides Innova Crysta on rent in Navi Mumbai for airport transfers, outstation trips, one-way and round-trip travel. Luxury and corporate cab services with affordable pricing.",
  "telephone": "+91 9892544084",
  "url": "https://www.omshreecab.com",
  "areaServed": {
    "@type": "City",
    "name": "Navi Mumbai, Maharashtra, India"
  },
  "serviceType": [
    "Innova Crysta on Rent",
    "Luxury Cab Rental",
    "Airport Transfer",
    "Outstation Cab",
    "One Way Cab",
    "Round Trip Taxi",
    "Corporate Cab Service"
  ]
};







  return (
    <div>
      


<Helmet>
  <title>Innova Crysta On Rent in Navi Mumbai | Omshree Cab</title>
  <meta
    name="description"
    content="Rent an Innova Crysta in Navi Mumbai with Omshree Cab. Available for airport transfers, one-way trips, round trips, outstation travel, and corporate use. Luxury and reliable service."
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/94.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Innovacrystaonrentinnavimumbai;